export enum ModeEnum {
  IMAGE_MODE_FLAG = 1,
  COLOR_MODE_FLAG = 2,
  GRADIENT_MODE_FLAG = 4,
}
